(function($) {
    $(function() {
        // Back to Department link
        $("a:contains('Back to Department')").addClass('back-to-department');
    });
} )( jQuery );